(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-product-carousel]').forEach(function(carousel) {
      const track = carousel.querySelector('[data-carousel-track]');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dots = carousel.querySelectorAll('[data-carousel-dot]');
      const slides = carousel.querySelectorAll('.product-carousel__slide');

      if (!track || slides.length === 0) return;

      let currentIndex = 0;
      const visibleProducts = parseInt(getComputedStyle(track).getPropertyValue('--visible-products'), 10) || 4;
      const maxIndex = Math.max(0, slides.length - visibleProducts);

      function updateCarousel() {
        const slideWidth = slides[0].offsetWidth;
        const gap = 16;
        const offset = currentIndex * (slideWidth + gap);
        track.style.transform = 'translateX(-' + offset + 'px)';

        // Update buttons
        if (prevBtn) prevBtn.disabled = currentIndex <= 0;
        if (nextBtn) nextBtn.disabled = currentIndex >= maxIndex;

        // Update dots
        dots.forEach(function(dot, index) {
          if (index === currentIndex) {
            dot.classList.add('product-carousel__dot--active');
          } else {
            dot.classList.remove('product-carousel__dot--active');
          }
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          if (currentIndex > 0) {
            currentIndex--;
            updateCarousel();
          }
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          if (currentIndex < maxIndex) {
            currentIndex++;
            updateCarousel();
          }
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          currentIndex = parseInt(this.dataset.carouselDot, 10);
          if (currentIndex > maxIndex) currentIndex = maxIndex;
          updateCarousel();
        });
      });

      // Initial state
      updateCarousel();

      // Handle resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          currentIndex = 0;
          updateCarousel();
        }, 250);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-product-gallery]').forEach(function(gallery) {
      const thumbnails = gallery.querySelectorAll('[data-gallery-thumbnail]');
      const images = gallery.querySelectorAll('[data-gallery-image]');
      const mainWrapper = gallery.querySelector('[data-gallery-main]');
      const zoomEnabled = mainWrapper && mainWrapper.hasAttribute('data-zoom-enabled');

      // Thumbnail click handling
      thumbnails.forEach(function(thumbnail) {
        thumbnail.addEventListener('click', function() {
          const imageId = this.dataset.imageId;

          // Update active thumbnail
          thumbnails.forEach(function(t) {
            t.classList.remove('product-gallery__thumbnail--active');
          });
          this.classList.add('product-gallery__thumbnail--active');

          // Update active image
          images.forEach(function(img) {
            if (img.dataset.imageId === imageId) {
              img.classList.add('product-gallery__main-image--active');
            } else {
              img.classList.remove('product-gallery__main-image--active');
            }
          });
        });
      });

      // Zoom functionality
      if (zoomEnabled && window.innerWidth > 1024) {
        images.forEach(function(imageContainer) {
          const lens = imageContainer.querySelector('[data-zoom-lens]');
          const result = imageContainer.querySelector('[data-zoom-result]');
          const img = imageContainer.querySelector('.product-gallery__image');
          const zoomImg = imageContainer.querySelector('.product-gallery__zoom-image');

          if (!lens || !result || !img || !zoomImg) return;

          imageContainer.addEventListener('mouseenter', function() {
            mainWrapper.classList.add('product-gallery__main-image-wrapper--zooming');
          });

          imageContainer.addEventListener('mouseleave', function() {
            mainWrapper.classList.remove('product-gallery__main-image-wrapper--zooming');
          });

          imageContainer.addEventListener('mousemove', function(e) {
            const rect = img.getBoundingClientRect();

            // Get cursor position relative to image
            let x = e.clientX - rect.left;
            let y = e.clientY - rect.top;

            // Lens dimensions
            const lensWidth = lens.offsetWidth / 2;
            const lensHeight = lens.offsetHeight / 2;

            // Prevent lens from going outside image bounds
            if (x < lensWidth) x = lensWidth;
            if (x > rect.width - lensWidth) x = rect.width - lensWidth;
            if (y < lensHeight) y = lensHeight;
            if (y > rect.height - lensHeight) y = rect.height - lensHeight;

            // Position lens
            lens.style.left = (x - lensWidth) + 'px';
            lens.style.top = (y - lensHeight) + 'px';

            // Calculate zoom ratio
            const zoomRatio = zoomImg.naturalWidth / img.offsetWidth;
            const resultWidth = result.offsetWidth;
            const resultHeight = result.offsetHeight;

            // Position zoomed image
            zoomImg.style.left = -(x * zoomRatio - resultWidth / 2) + 'px';
            zoomImg.style.top = -(y * zoomRatio - resultHeight / 2) + 'px';
          });
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity-selector"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      const input = selector.querySelector('[data-quantity-input]');
      const minusBtn = selector.querySelector('[data-quantity-minus]');
      const plusBtn = selector.querySelector('[data-quantity-plus]');

      if (!input || !minusBtn || !plusBtn) return;

      const min = parseInt(input.min, 10) || 1;
      const max = parseInt(input.max, 10) || 999;

      minusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value, 10) || min;
        if (currentValue > min) {
          input.value = currentValue - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      plusBtn.addEventListener('click', function() {
        const currentValue = parseInt(input.value, 10) || min;
        if (currentValue < max) {
          input.value = currentValue + 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      input.addEventListener('change', function() {
        let value = parseInt(this.value, 10);
        if (isNaN(value) || value < min) {
          this.value = min;
        } else if (value > max) {
          this.value = max;
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
